export default __webpack_public_path__ + "images/default-64.png";